import React, { Fragment, PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import Tooltip from "@mui/material/Tooltip";
import Button from "../../Components/common/Button";
import Menu from "../../Components/Menu/CommonMenu";
import MenuItem from "../../Components/common/MenuItem";
import TextField from "../../Components/common/TextField";
import { Trans as Translate } from "react-i18next";

class NavbarSearchMenu extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      search: "",
    };
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget, search: "" });
  };

  handleClose = () => {
    this.setState({ anchorEl: null, search: "" });
  };

  handleSearchChange = (event) => {
    this.setState({ search: event.target.value });
  };

  navigate = (href) => {
    this.handleClose();
    if (this.props.collapseMenu) {
      this.props.collapseMenu();
    }
    if (href) {
      this.props.history.push(href);
    }
  };

  getFilteredItems = () => {
    const { items = [] } = this.props;
    const search = (this.state.search || "").trim().toLowerCase();
    if (!search) return items;
    return items.filter((item) =>
      String(item.title || "")
        .toLowerCase()
        .includes(search),
    );
  };

  render() {
    const { anchorEl } = this.state;
    const { themecolors } = this.props;
    const filteredItems = this.getFilteredItems();

    return (
      <Fragment>
        <Tooltip
          title={<Translate i18nKey="searchModules" />}
          placement="bottom"
          classes={{
            popper: "menu-popper",
            tooltip: "menu-popper-tooltip",
          }}
        >
          <Button
            aria-owns={anchorEl ? "navbar-search-menu" : undefined}
            aria-haspopup="true"
            className="button-narrow theme-green text-capitalize"
            onClick={this.handleClick}
            style={{ minWidth: 40, padding: "4px 8px" }}
          >
            <SearchIcon style={{ fontSize: 22 }} />
          </Button>
        </Tooltip>
        <Menu
          id="navbar-search-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          themecolors={themecolors}
          className="navbar-search-menu"
        >
          <div
            style={{ padding: "8px 12px", minWidth: 260 }}
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
          >
            <TextField
              autoFocus
              fullWidth
              size="small"
              margin="dense"
              variant="outlined"
              label={<Translate i18nKey="searchModules" />}
              value={this.state.search}
              onChange={this.handleSearchChange}
            />
          </div>
          <div style={{ maxHeight: 320, overflowY: "auto", minWidth: 260 }}>
            {filteredItems.length ? (
              filteredItems.map((item) => {
                const ItemIcon = item.icon;
                return (
                  <MenuItem
                    key={item.key || item.href || item.title}
                    onClick={() => this.navigate(item.href)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    {ItemIcon ? (
                      <ItemIcon fill="currentColor" width={18} height={18} />
                    ) : null}
                    <span>{item.title}</span>
                  </MenuItem>
                );
              })
            ) : (
              <MenuItem disabled>
                <Translate i18nKey="notFound" />
              </MenuItem>
            )}
          </div>
        </Menu>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  themecolors: state.themeColors,
});

export default connect(mapStateToProps)(withRouter(NavbarSearchMenu));
